export default __webpack_public_path__ + "static/media/CustomerService.d72e306d.png";